import { BnAction } from '../../common/bn-action';
import { sharedStyles } from '../../styles/shared-styles';
import { css } from '../../utility/lit-entity';

class ReadyButton extends BnAction {
  constructor() {
    super();
    this.actionname = 'ready-work-order';
    this.errortext = 'Failed to mark work order as ready.';
    this.successtext = 'Work Order has been marked ready.';
    this.submittext = 'Ready';
    this.suppressheader = true;
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline-block;
      }
    `];
  }
}

window.customElements.define('ready-button', ReadyButton);
